import {Container} from "inversify";
import ApiService from "./apiService";

export const serviceContainer = new Container();

export function bindApiService(accessToken: string) {
    if (serviceContainer.isBound(ApiService)) {
        serviceContainer.unbind(ApiService);
    }

    serviceContainer.bind(ApiService).toDynamicValue(() => new ApiService(accessToken)).inSingletonScope();
}

export function getApiServiceOrNull() {
    return serviceContainer.isBound(ApiService) ? serviceContainer.get(ApiService) : null;
}

const cachedToken = localStorage.getItem("cached_token");
if (cachedToken) {
    bindApiService(cachedToken);
}
